import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { Card, Form, Input } from 'antd'

const FormItem = Form.Item

const JoinUsProfileContactStep = ({ form, profile }) => {
  const { getFieldDecorator } = form

  if (isEmpty(profile)) {
    return (
      <React.Fragment>
        <Card title="Profile" type="inner">
          <FormItem
            label="Name"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'name',
              {}
            )(<Input placeholder="First Name, Last Name" />)}
          </FormItem>
          <FormItem
            label="Nationality(ies)"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'nationality',
              {}
            )(<Input placeholder="Enter nationality or nationalities" />)}
          </FormItem>
          <FormItem
            label="Qualifications"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'qualification',
              {}
            )(<Input placeholder="Enter qualifications" />)}
          </FormItem>
          <FormItem
            label="Years of Experience"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'yearsofexperience',
              {}
            )(<Input placeholder="Enter years of experience" />)}
          </FormItem>
          <FormItem
            label="Countries of Experience"
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
          >
            {getFieldDecorator(
              'countryofexperience',
              {}
            )(
              <Input placeholder="Enter countries of experience separated by commas" />
            )}
          </FormItem>
        </Card>
        <Card title="Contacts" type="inner">
          <FormItem
            label="Phone"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'phone',
              {}
            )(<Input placeholder="Enter phone number" />)}
          </FormItem>
          <FormItem
            label="Email"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator('email', {
              rules: [
                {
                  type: 'email',
                  message: 'The input is not a valid email!',
                },
                {
                  required: true,
                  message: 'Please input your email!',
                },
              ],
            })(<Input placeholder="Enter email address" />)}
          </FormItem>
          <FormItem
            label="Location"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 22 }}
          >
            {getFieldDecorator(
              'location',
              {}
            )(<Input placeholder="Enter current location" />)}
          </FormItem>
        </Card>
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <Card title="Profile" type="inner">
        <FormItem label="Name" labelCol={{ span: 5 }} wrapperCol={{ span: 19 }}>
          {getFieldDecorator('name', {
            initialValue: profile.name ? profile.name : '',
          })(<Input placeholder="First Name, Last Name" />)}
        </FormItem>
        <FormItem
          label="Nationality(ies)"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('nationality', {
            initialValue: profile.nationality ? profile.nationality : '',
          })(<Input placeholder="Enter nationality or nationalities" />)}
        </FormItem>
        <FormItem
          label="Qualifications"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('qualification', {
            initialValue: profile.qualification ? profile.qualification : '',
          })(<Input placeholder="Enter qualifications" />)}
        </FormItem>
        <FormItem
          label="Years of Experience"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('yearsofexperience', {
            initialValue: profile.yearsofexperience
              ? profile.yearsofexperience
              : '',
          })(<Input placeholder="Enter years of experience" />)}
        </FormItem>
        <FormItem
          label="Countries of Experience"
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
        >
          {getFieldDecorator('countryofexperience', {
            initialValue: profile.countryofexperience
              ? profile.countryofexperience
              : '',
          })(
            <Input placeholder="Enter countries of experience separated by commas" />
          )}
        </FormItem>
      </Card>
      <Card title="Contacts" type="inner">
        <FormItem
          label="Phone"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('phone', {
            initialValue: profile.phone ? profile.phone : '',
          })(<Input placeholder="Enter phone number" />)}
        </FormItem>
        <FormItem
          label="Email"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('email', {
            initialValue: profile.email ? profile.email : '',
            rules: [
              {
                type: 'email',
                message: 'The input is not a valid email!',
              },
              {
                required: true,
                message: 'Please input your email!',
              },
            ],
          })(<Input placeholder="Enter email address" />)}
        </FormItem>
        <FormItem
          label="Location"
          labelCol={{ span: 2 }}
          wrapperCol={{ span: 22 }}
        >
          {getFieldDecorator('location', {
            initialValue: profile.location ? profile.location : '',
          })(<Input placeholder="Enter current location" />)}
        </FormItem>
      </Card>
    </React.Fragment>
  )
}

export default JoinUsProfileContactStep
